export interface ITceFormula {
    networkPartnerCenterCount: number,
    centerNcsScore: number,
    networkNcsScore: number,
    centerCompositeScore: number,
    centerCompositeScorePercent: number,
    networkCompositeScore: number,
    compositeScoreRank: number,
    centerForecastedFloat: number,
    networkForecastedFloat: number,
    centerShareOfFloat: number,
    networkShareOfFloat: number,
    shareOfFloatRank: number,
    centerHardToPlaceDonorAddBacks: number,
    networkHardToPlaceDonorAddBacks: number,
    hardToPlaceDonorAddBacksRank: number,
    centerTargetedChainEnds: number,
    networkTargetedChainEnds: number,
    targetedChainEndsRank: number,
}